import { ColorsBadge } from '@/lib/v2/components/BadgeText/types';
import { ColorsIcon } from '@/lib/v2/components/IconSvg/types';

import {
  ETriggerActivityType,
  JourneyMessageTemplatesStatus,
} from '@/src/infrastructure/interfaces/IAutomation.interface';
import { IFlowData } from '@/src/modules/AutomationModuleNew/types/flows';

import {
  EActionTypes,
  EDateFilterType,
} from '@/modules/CampaignsModule/interfaces/CampaignActions';

export enum EMaxMinLength {
  MIN_LENGTH = 2,
  NAME_MAX = 60,
  OBJECTIVE_MAX = 150,
  OTHER_STRATEGY_MAX = 30,
  DESCRIPTION_EVENT_MAX = 250,
}

export interface ICheckNameResource {
  id?: string;
  name?: string;
}

export enum ModalType {
  EDIT = 'edit',
}

export enum ScreenType {
  MAIN = 'main',
}

export interface ITableCampaignActions {
  action: IFlowData;
}

export interface IOrderByCell {
  id: string;
  isAsc: boolean | undefined;
}

export interface JourneysMessagesTable {
  campaignId?: number;
  id: number;
  internalStatusId: number;
  name: string;
  status: JourneyMessageTemplatesStatus;
  creationDate: string;
  lastUpdate: string;
}

export enum EJourneyMessageState {
  ACTIVE = 'active',
  INACTIVE = 'inactive',
  DRAFT = 'draft',
}

export interface IActionState {
  type: 'draft' | 'active' | 'finished' | 'inactive';
  values: number[];
  badge: ColorsBadge;
  background: Exclude<ColorsIcon, 'white'>;
}

export interface CampaignActionsListFilters {
  campaignId?: number | undefined;
  type?: EActionTypes;
  page?: number;
  limit?: number;
  search?: string;
  status?: (string | number)[];
  channel?: number[];
  startDate?: Date | null;
  endDate?: Date | null;
  sortField?: string;
  sortOrder?: string;
  dateFilterField?: EDateFilterType;
}

export interface RulesTable {
  id: number;
  name: string;
  internalStatusId: number;
  creationDate: string;
  lastUpdate: string;
  campaignId: number;
  ruleType?: number;
  audience: number | null;
  exeDate: string | null;
  status: EJourneyMessageState;
}

export interface JourneyMessageCreatedResponse {
  id: number;
  name: string;
  internalStatusId: number;
  creationDate: string;
  lastUpdate: string;
  campaignId: number;
  status: EJourneyMessageState;
}

export interface RuleCreatedResponse {
  id: number;
  name: string;
  internalStatusId: number;
  creationDate: string;
  lastUpdate: string;
  campaignId: number;
  ruleType: ETriggerActivityType;
  audience: number;
  exeDate: string;
  status: EJourneyMessageState;
}
